export default function dropdownStyles(min_width = 85, hideFirst = false) {
  console.warn(min_width, "min-width");
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;

  const dropdownStyle = {
    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
    borderRadius: "7px",
    marginTop: "5px",
    borderRadius: "8px",

    "& .MuiMenuItem-root": {
      padding: "8px 11px",
      fontSize: "11px",
      fontWeight: "500",
      color: "#525050",
      lineHeight: "1",
      borderRadius: "5px",
      span: {
        color: "#BDBDBD",
        fontSize: "10px",
      },
      "&:hover": {
        backgroundColor: "#F4F4F4",
        //   color: "#111ae9",
        color: "#525050",
      },
      "&:not(:last-child)": {
        //   marginBottom: "10px",
      },
      "&:first-child": {
        display: hideFirst ? "none" : "block",
      },
    },
    "& .Mui-selected": {
      background: "#F4F4F4 !important",
    },

    "& .MuiList-root": {
      padding: "6px 3px",
      minWidth: { min_width } + "px",
    },
  };
  return dropdownStyle;
}
